import { render, staticRenderFns } from "./AddStudentSidebar.vue?vue&type=template&id=5356cb26&scoped=true&"
import script from "./AddStudentSidebar.vue?vue&type=script&lang=js&"
export * from "./AddStudentSidebar.vue?vue&type=script&lang=js&"
import style0 from "./AddStudentSidebar.vue?vue&type=style&index=0&id=5356cb26&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5356cb26",
  null
  
)

export default component.exports